export default "__VITE_ASSET__DrlfzM1Q__"